import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { ActivatedRouteSnapshot, provideRouter, withViewTransitions } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';

/** A rota mais profunda é um painel sobre o que já estava no ecrã? */
function isOverlay(route: ActivatedRouteSnapshot): boolean {
  let deepest = route;
  while (deepest.firstChild) {
    deepest = deepest.firstChild;
  }
  return deepest.data['overlay'] === true;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withViewTransitions({
      // Abrir um painel sobre a página não é mudar de página. Deixar correr a transição de
      // rota tapava o painel com a fotografia do ecrã anterior até ela acabar — parecia que
      // ele nascia atrás de tudo e só depois vinha à frente.
      onViewTransitionCreated: ({ transition, to, from }) => {
        if (isOverlay(to) || isOverlay(from)) {
          transition.skipTransition();
        }
      },
    })),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
  ],
};
